import React, { useId } from 'react';

interface RobotLogoProps {
  size?: number;
  className?: string;
}

/* Flat version of the 3D mascot (brand/blender/zinify_bot.py):
   indigo head, dark face screen, pill eyes, smile and blush. */
const RobotLogo: React.FC<RobotLogoProps> = ({ size = 28, className }) => {
  const shell = `shell-${useId()}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient id={shell} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366f1" />
          <stop offset="1" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>

      {/* Antenna */}
      <line x1="16" y1="4.5" x2="16" y2="8" stroke="#c7d2fe" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="16" cy="3.4" r="2" fill="#f5f6fb" />

      {/* Ear pods */}
      <rect x="1.4" y="13.2" width="3" height="7.6" rx="1.5" fill="#f5f6fb" />
      <rect x="27.6" y="13.2" width="3" height="7.6" rx="1.5" fill="#f5f6fb" />

      {/* Head + face screen */}
      <rect x="3.5" y="7.5" width="25" height="20" rx="8" fill={`url(#${shell})`} />
      <rect x="6.8" y="11" width="18.4" height="13" rx="5" fill="#0b0c16" />

      {/* Eyes, smile, blush */}
      <rect x="11" y="13.8" width="2.8" height="4.2" rx="1.4" fill="#eef2ff" />
      <rect x="18.2" y="13.8" width="2.8" height="4.2" rx="1.4" fill="#eef2ff" />
      <path d="M14.2 19.9 Q16 21.4 17.8 19.9" stroke="#eef2ff" strokeWidth="1.2" strokeLinecap="round" />
      <ellipse cx="9.7" cy="19.6" rx="1.3" ry="0.65" fill="#f472b6" />
      <ellipse cx="22.3" cy="19.6" rx="1.3" ry="0.65" fill="#f472b6" />
    </svg>
  );
};

export default RobotLogo;
